import { effect, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

/** Sin sesión manda al login global y vuelve a la página pedida al entrar. */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) return true;
  return router.createUrlTree(['/auth/login'], { queryParams: { returnTo: state.url } });
};

/**
 * El guard solo actúa al navegar. Si la sesión se cierra estando en una página que la
 * exige (cerrar sesión, todos los dispositivos, refresh vencido), sale a la página
 * padre: el inicio de la tienda o la portada. Se llama una vez desde App.
 */
export function leaveGuardedRouteOnLogout(): void {
  const auth = inject(AuthService);
  const router = inject(Router);
  let wasAuthenticated = auth.isAuthenticated();
  effect(() => {
    const isAuthenticated = auth.isAuthenticated();
    if (wasAuthenticated && !isAuthenticated) {
      const parentSegments: string[] = [];
      for (let r = router.routerState.snapshot.root.firstChild; r; r = r.firstChild) {
        if (r.routeConfig?.canActivate?.includes(authGuard)) {
          router.navigateByUrl('/' + parentSegments.join('/'));
          break;
        }
        parentSegments.push(...r.url.map((s) => s.path));
      }
    }
    wasAuthenticated = isAuthenticated;
  });
}
